<template>
<div class="new-custom" :style="columnMargin">
  <img class="bg-img" :src="bgImg" />
  <img @click="doLocationHref(item.adList)" class="coupon-img" :src="item.adList.imgUrl" />
  <div class="prod-bar">
    <div @click="toProdDetail(prod)" v-for="(prod,index) in item.prodList" :key="index" class="prod-one">
      <div class="prod-img-bar">
        <img class="prod-img" :src="prod.imgUrl" />
      </div>
      <div class="prod-name">{{prod.prodName}}</div>
      <div class="prod-price">最低<span class="prod-price-yuan font-size-10">¥</span><span class="font-size-15">{{prod.prodPrice}}</span></div>
    </div>
  </div>
  <div class="bottom-height"></div>
</div>
</template>

<script>
export default { 
  name: 'NewCustom',
  data() {
    return {
      
    }
  },
  props: {
    item: Object,
  },
  components: {
  },
  created() {
  },
  mounted() {
  },
  computed: {
    bgImg: function(){
      return '/clientmodule/distVueCli/newHomeVue/img/new_custom_bg_radius.png'
    },
    columnMargin(){
      var obj = {}
      if(this.item.marginObj){
        obj={
          'margin-top': this.item.marginObj.top,
          'margin-bottom': this.item.marginObj.bottom
        }
      }
			return obj
    }
  },
  methods: {
    // doLocationHref(url){
    //   url && (window.location.href = url)
    // },
    doLocationHref(obj){
      var self = this
      this.$store.commit('doTrack',{
        href: obj.adHrefUrl,
        columnDefineId: self.item.columnDefineId,
        ccId: obj.ccId,
        adId: obj.adId,
        adName: obj.adName,
        idType: 'adId'
      });
      window.location.href = obj.adHrefUrl
    },
    toProdDetail(obj){
      var self = this
      var url = '/client/cpd_' + obj.prodId + '.jhtml';
      obj.prodUrl && (url = obj.prodUrl);
      this.$store.commit('doTrack',{
        href: url,
        columnDefineId: self.item.columnDefineId,
        ccId: obj.ccId,
        adId: obj.prodId,
        adName: obj.prodName,
        idType: 'prodId'
      });
      window.location.href = url
    },
  }
}
</script>

<style scoped>
.new-custom{
  width: 369px;
  margin-left: 3px;
  /* background: url(./assets/new_custom_bg.png) no-repeat bottom 5px center; */
  /* background-size: 353px 221px; */
  padding-bottom: 5px;
  position: relative
}
.bg-img{
  width: 353px;
  height: 221px;
  position: absolute;
  bottom: 5px;
  left: 8px;
  z-index: -1;
  display: block;
}
.coupon-img{
  width: 100%;
  display: block 
}
.prod-bar{
  width: 339px;
  height: 117px;
  margin-left: 18px;
  position: relative;
  top: -10px;
  z-index: 2;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  display: flex
}
.prod-bar::-webkit-scrollbar{
  width: 0;
  height: 0
}
.prod-one{
  flex-basis: 96px;
  flex-shrink: 0;
  white-space: nowrap;
  height: 117px;
  background-image: linear-gradient(180deg, #FFFFFF 0%, #FFF7EA 100%);
  border-radius: 6px;
  margin-right: 6px
}
.prod-img-bar{
  width: 100%;
  height: 68px
}
.prod-img{
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.bottom-height{
  width: 100%;
  height: 6px
}
.prod-name{
  width: 88px;
  height: 19px;
  line-height: 19px;
  margin-left: 4px;
  white-space: normal;
  word-break: break-all;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  color: #333
}
.prod-price{
  margin-left: 4px;
  color: #F72D17;
  font-size: 9px;
  display: flex;
  align-items: baseline;
}
.font-size-10{
  font-size: 10px
}
.font-size-15{
  font-size: 15px
}
.prod-price-yuan{
  margin-left: 3px;
  margin-right: 1px
}
</style>